import styled from 'styled-components';
import {
  colorBlack200,
  colorBlack900,
  colorGrey100,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
} from 'styles';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Title = styled.h2`
  margin: 8px 0;
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: ${colorBlack900};

  @media ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  min-width: 480px;
  border-collapse: collapse;
  font-family: ${fontFamilyPrimary};
`;

export const TableHead = styled.thead`
  background: ${colorWhite};
`;

export const HeadRow = styled.tr`
  height: 48px;
`;

export const HeadCell = styled.th`
  padding: 12px 16px;
  font-size: 13px;
  line-height: 24px;
  font-weight: 400;
  color: ${colorBlack200};
  text-align: left;

  &:nth-child(2),
  &:nth-child(3) {
    width: 33%;
  }
`;

export const BodyRow = styled.tr`
  height: 48px;
  background: ${({ $isEven }) => ($isEven ? '#fbfbfb' : colorWhite)};
  box-shadow: inset 0 1px 0 ${colorGrey100};
`;

export const LabelCell = styled.td`
  padding: 0 16px;
  font-size: 14px;
  line-height: 28px;
  color: ${colorBlack200};
  white-space: nowrap;
`;

export const RateCell = styled.td`
  padding: 0 16px;
  text-align: left;
`;

export const RateValue = styled.span`
  font-size: 18px;
  line-height: 1;
  font-weight: 700;
  color: ${colorBlack900};
`;

export const RateContent = styled.div`
  display: inline-flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 4px;
`;

export const TrendIcon = styled.span`
  display: inline-flex;
  align-items: flex-end;
  line-height: 0;

  & svg {
    margin-top: ${({ $fall }) => ($fall ? '2px' : '0')};
  }
`;
